import Theme from '@adsk/alloy-react-theme';

export const infoIconWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  marginTop: '5px',
  ...Theme.typography.bodySmall,
};

export const infoIconStyle = {
  marginRight: '5px',
  color: Theme.colors.charcoal700,
};
